import { useCallback, useState } from 'react';

// The page's Simple / Detailed view, remembered per browser (a convenience; simple by default).
const STORAGE_KEY = 'bonusRequests.viewMode';
export const VIEW_MODES = ['simple', 'detailed'];

const read = () => {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return VIEW_MODES.includes(v) ? v : 'simple';
  } catch {
    return 'simple';
  }
};

export function useViewMode() {
  const [mode, setModeState] = useState(read);
  const setMode = useCallback((next) => {
    setModeState(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // storage blocked: the choice lasts for this visit only
    }
  }, []);
  return [mode, setMode];
}
